export default __webpack_public_path__ + "static/media/maul.91509197.png";